import React, {useState} from 'react';
import {Combobox} from '@headlessui/react';
import {XMarkIcon} from '@heroicons/react/24/outline';
import useSearchParams from '../../../useSearchParams';
import Header from '../Header';
import Footer from './Footer';

const DepartmentPositionFilter = () => {
  const {query, setQuery} = useSearchParams();
  const [departmentInput, setDepartmentInput] = useState('');
  const [positionInput, setPositionInput] = useState('');

  const currentDepartments = query?.departments || [];
  const currentPositions = query?.positions || [];

  const handleDepartmentKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      e.key === 'Enter' &&
      e.nativeEvent.isComposing === false &&
      departmentInput.trim()
    ) {
      if (!currentDepartments.includes(departmentInput.trim())) {
        const newDepartments = [...currentDepartments, departmentInput.trim()];
        setQuery({
          departments: newDepartments,
          page: 1,
        });
        setDepartmentInput('');
      }
    }
  };

  const handlePositionKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      e.key === 'Enter' &&
      e.nativeEvent.isComposing === false &&
      positionInput.trim()
    ) {
      if (!currentPositions.includes(positionInput.trim())) {
        const newPositions = [...currentPositions, positionInput.trim()];
        setQuery({
          positions: newPositions,
          page: 1,
        });
        setPositionInput('');
      }
    }
  };

  const removeDepartment = (departmentToRemove: string) => {
    const newDepartments = currentDepartments.filter(
      (dept: string) => dept !== departmentToRemove
    );
    setQuery({
      departments: newDepartments.length > 0 ? newDepartments : [],
      page: 1,
    });
  };

  const removePosition = (positionToRemove: string) => {
    const newPositions = currentPositions.filter(
      (pos: string) => pos !== positionToRemove
    );
    setQuery({
      positions: newPositions.length > 0 ? newPositions : [],
      page: 1,
    });
  };

  const clearAll = () => {
    setQuery({
      departments: [],
      positions: [],
    });
  };

  return (
    <>
      <Header title="部署/役職" />
      <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-4">
          <div className="flex flex-col gap-2">

            {/* 部署フィールド */}
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium text-gray-700">部署</label>
              <div className="p-3 border border-c-border rounded flex gap-2 items-center flex-wrap min-h-[40px]">
                {currentDepartments.map((department: string) => (
                  <span
                    key={department}
                    className="bg-c-bg h-7 rounded text-sm px-3 flex items-center gap-1"
                  >
                    {department}
                    <button
                      onClick={() => removeDepartment(department)}
                      className="flex items-center justify-center cursor-pointer hover:bg-gray-200 rounded-full p-0.5 ml-1"
                    >
                      <XMarkIcon className="h-4 w-4" />
                    </button>
                  </span>
                ))}
                <Combobox value={null}>
                  <Combobox.Input
                    className="flex-1 outline-none min-w-[120px] text-sm"
                    value={departmentInput}
                    onChange={(e) => setDepartmentInput(e.target.value)}
                    onKeyDown={handleDepartmentKeyDown}
                    placeholder="部署名を入力..."
                  />
                </Combobox>
              </div>
            </div>

            {/* 役職フィールド */}
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium text-gray-700">役職</label>
              <div className="p-3 border border-c-border rounded flex gap-2 items-center flex-wrap min-h-[40px]">
                {currentPositions.map((position: string) => (
                  <span
                    key={position}
                    className="bg-c-bg h-7 rounded text-sm px-3 flex items-center gap-1"
                  >
                    {position}
                    <button
                      onClick={() => removePosition(position)}
                      className="flex items-center justify-center cursor-pointer hover:bg-gray-200 rounded-full p-0.5 ml-1"
                    >
                      <XMarkIcon className="h-4 w-4" />
                    </button>
                  </span>
                ))}
                <Combobox value={null}>
                  <Combobox.Input
                    className="flex-1 outline-none min-w-[120px] text-sm"
                    value={positionInput}
                    onChange={(e) => setPositionInput(e.target.value)}
                    onKeyDown={handlePositionKeyDown}
                    placeholder="役職名を入力..."
                  />
                </Combobox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer onClear={clearAll} />
    </>
  );
};

export default DepartmentPositionFilter;